import {
    AllLayouts,
    DisplayLayout,
    LayoutFlag,
    SocialLayout,
} from '../enums/creativeLayouts/CreativeLayouts';
import { mysterymanurl, noAgentPhoto } from './helpers';

export const sanitizeLayoutString = (layout: unknown): string => {
    if (Array.isArray(layout)) {
        return layout.join(',');
    }
    if (layout === null || layout === undefined) {
        return '';
    }
    return String(layout);
};

export const getDefaultLayoutString = (): string => {
    const firstSocial = Object.values(SocialLayout)[0];
    const firstDisplay = Object.values(DisplayLayout)[0];
    return `${firstSocial},${firstDisplay}`;
};

export const getActiveLayouts = (layoutString?: string | null | undefined): string[] => {
    const safeString = layoutString ? String(layoutString) : '';
    return safeString.split(/[\s,|]+/).filter(Boolean);
};

export const shouldShowAgentPhoto = (
    layoutString: string | null | undefined,
    agentPhotoUrl: string | null | undefined
): boolean => {
    const activeLayouts = getActiveLayouts(layoutString);
    const hasNoPhotoFlag = activeLayouts.includes(LayoutFlag.NO_AGENT_PHOTO);
    return !hasNoPhotoFlag && agentPhotoUrl !== mysterymanurl;
};

export const toggleAgentPhotoLayout = (
    layoutString: string | null | undefined,
    isShowingPhoto: boolean
): string => {
    let layouts = getActiveLayouts(layoutString);

    if (isShowingPhoto) {
        layouts = layouts.filter((id) => id !== LayoutFlag.NO_AGENT_PHOTO);
    } else {
        if (!layouts.includes(LayoutFlag.NO_AGENT_PHOTO)) {
            layouts.push(LayoutFlag.NO_AGENT_PHOTO);
        }
    }
    return layouts.join(',');
};

export const getLayoutIdFromName = (name?: string | null): string | null => {
    if (!name) return null;

    const normalizedName = name.trim().toUpperCase().replace(/\s+/g, '_');
    if (Object.keys(AllLayouts).includes(normalizedName)) {
        return AllLayouts[normalizedName as keyof typeof AllLayouts];
    }

    return null;
};

export const buildInitialFbLayout = (
    currentLayoutString?: string | null,
    socialPipeline?: string | null,
    displayPipeline?: string | null
): string => {
    const previousLayouts = getActiveLayouts(currentLayoutString);

    const existingFlags = previousLayouts.filter((id) =>
        Object.values(LayoutFlag).includes(id as LayoutFlag)
    );

    const newSocial = getLayoutIdFromName(socialPipeline);
    const newDisplay = getLayoutIdFromName(displayPipeline);

    const initialLayouts = [newSocial, newDisplay, ...existingFlags].filter(Boolean);

    return Array.from(new Set(initialLayouts)).join(',');
};

export const getProcessedAgentPhotoUrl = (
    photoUrl: string | null | undefined,
    layoutString: string | null | undefined
): string =>
    !photoUrl ||
    photoUrl.includes(noAgentPhoto) ||
    getActiveLayouts(layoutString).includes(LayoutFlag.NO_AGENT_PHOTO)
        ? mysterymanurl
        : photoUrl;
